export default {
    actions: {
        async fetchCategories(ctx) {
            let url = '/api/menu/main-menu';
            axios.get(url)
                .then(response => {
                    if (response.status == 200) {
                        ctx.commit('setCategories', response.data);
                    }
                    else ctx.commit('setCategories', null);

                })
        },

        async fetchBrands(ctx, params) {
            let url = '/api/filter/brands';
            axios.post(url, params)
                .then(response => {
                    if (response.status == 200) {
                        ctx.commit('setBrands', response.data);
                    }
                    else ctx.commit('setBrands', null);

                })
        },

        async fetchCatFilters(ctx, params) {
            let url = '/api/filter/catFilters';
            axios.post(url, params)
                .then(response => {
                    if (response.status == 200) {
                        ctx.commit('setCameraTypes', response.data);
                        ctx.commit('setMatrixSizes', response.data);
                        ctx.commit('setLensTypes', response.data);
                        ctx.commit('setBayonets', response.data);
                        ctx.commit('setMaximumApertures', response.data);
                        ctx.commit('setFocalLengths', response.data);
                        ctx.commit('setCompatibilities', response.data);
                        ctx.commit('setByTemperatures', response.data);
                        ctx.commit('setLightTypes', response.data);
                        ctx.commit('setLEDs', response.data);
                    }
                    else {
                        ctx.commit('setCameraTypes', null);
                        ctx.commit('setMatrixSizes', null);
                        ctx.commit('setLensTypes', null);
                        ctx.commit('setBayonets', null);
                        ctx.commit('setMaximumApertures', null);
                        ctx.commit('setFocalLengths', null);
                        ctx.commit('setCompatibilities', null);
                        ctx.commit('setByTemperatures', null);
                        ctx.commit('setLightTypes', null);
                        ctx.commit('setLEDs', null);
                    }
                })
        },
    },

    mutations: {
        setCategories(state, data) {
            state.top_category = data.mainMenu;
            state.left_category = data.leftMenu;
            state.max_price = data.maxPrice;
        },
        setBrands(state, data) {
            state.brands = data.brands;
        },
        setCameraTypes(state, data) {
            state.camera_types = data.camera_types;
        },
        setMatrixSizes(state, data) {
            state.matrix_sizes = data.matrix_sizes;
        },
        setLensTypes(state, data) {
            state.lens_types = data.lens_types;
        },
        setBayonets(state, data) {
            state.bayonets = data.bayonets;
        },
        setMaximumApertures(state, data) {
            state.maximum_apertures = data.maximum_apertures;
        },
        setFocalLengths(state, data) {
            state.focal_lengths = data.focal_lengths;
        },
        setCompatibilities(state, data) {
            state.compatibilities = data.compatibilities;
        },
        setByTemperatures(state, data) {
            state.by_temperatures = data.by_temperatures;
        },
        setLightTypes(state, data) {
            state.light_types = data.light_types;
        },
        setLEDs(state, data) {
            state.LEDs = data.LEDs;
        }
    },

    state: {
        top_category: null,
        left_category: null,
        brands: null,
        max_price: null,
        camera_types: null,
        matrix_sizes: null,
        lens_types: null,
        bayonets: null,
        maximum_apertures: null,
        focal_lengths: null,
        compatibilities: null,
        by_temperatures: null,
        light_types: null,
        LEDs: null,

    },

    getters: {
        getTopCategories(state) {
            return state.top_category
        },
        getLeftCategories(state) {
            return state.left_category
        },
        getBrands(state) {
            return state.brands
        },
        getCameraTypes(state) {
            return state.camera_types
        },
        getMatrixSizes(state) {
            return state.matrix_sizes
        },
        getLensTypes(state) {
            return state.lens_types
        },
        getBayonets(state) {
            return state.bayonets
        },
        getMaximumApertures(state) {
            return state.maximum_apertures
        },
        getFocalLengths(state) {
            return state.focal_lengths
        },
        getCompatibilities(state) {
            return state.compatibilities
        },
        getByTemperatures(state) {
            return state.by_temperatures
        },
        getLightTypes(state) {
            return state.light_types
        },
        getLEDs(state) {
            return state.LEDs
        },
        getMaxPrice(state) {
            return state.max_price
        }
    },
}
